class HDTrade {

    /** Constructor **/
    constructor() {
    }

    init() {
        this.setBodyTopPadding();
        this.copyFormData();
        this.aszfCheckbox();
        this.listSortDropdown();
        this.dropdownBehavior();
        this.filterBarBehaviour();
        this.hamburgerMenu();
        this.accordionToggle();
    }

    /** Set body top padding & Popup Cart top property for fixed menubar **/
    setBodyTopPadding() {
        const menuHeight = 50;

        const container = document.querySelector('#app > .container');
        const popupCart = document.querySelector('#collapseCart');

        container.style.paddingTop = menuHeight + 'px';

        if (popupCart !== null) {
            popupCart.style.top = menuHeight + 'px';
        }
    }

    /** Hamburger open/close animation **/
    hamburgerMenu() {
        const hamburgerButton = document.querySelectorAll('.burger');

        hamburgerButton.forEach((item) => {
            item.addEventListener('click', () => {
                item.classList.toggle('burger-active');
            });
        });
    }

    /** Responsive dropdown menu behavior **/
    dropdownBehavior() {

        const $dropdownMenuButton = $('.header-menubar .burger');
        const $dropdownMenu = $('.header-dropdown-menu');
        const $stickyBottombar = $('#sticky-bottombar');
        const $stickyDroprownButton = $('#sticky-menu .burger');
        const $stickyBarHeight = $('#sticky-menu').outerHeight();
        const $stickyDropdownMenu = $('.sticky-dropdown-menu');

        class DropdownFunctions {
            constructor(button, menu, heightItem) {
                this.button = button;
                this.menu = menu;
                this.heightItem = heightItem;
            }

            setSlideToggle() {
                const that = this;
                this.button.on('click', () => {
                    that.menu.slideToggle(200);
                });
            }

            setProperHeight() {
                this.menu.css('top', $stickyBarHeight);
                this.heightItem.css('margin-bottom', $stickyBarHeight);
            }

            toggleAndHeight() {
                this.setProperHeight();
                this.setSlideToggle();
            }
        }

        const headerBurger = new DropdownFunctions($dropdownMenuButton, $dropdownMenu);
        const stickyBurger = new DropdownFunctions($stickyDroprownButton, $stickyDropdownMenu, $stickyBottombar);

        stickyBurger.toggleAndHeight();
        headerBurger.setSlideToggle();
    }

    /** Sidebar Filer respo behaviour **/
    filterBarBehaviour() {
        const filterButton = document.querySelector('#filter-respo-button');
        const filterMenu = document.querySelector('#cat-filter-wrapper');
        const filterCloseButton = document.querySelector('#filter-respo-remove');
        const bodyBackdrop = document.querySelector('#cat-filter-backdrop');

        if (filterButton === null) {
            return;
        }

        const items = [
            filterButton,
            filterCloseButton,
            bodyBackdrop
        ];

        items.forEach((item) => {

            if (item !== null) {
                item.addEventListener('click', (e) => {
                    e.preventDefault();
                    toggleSidebarClasses();
                });
            }
        });

        function toggleSidebarClasses() {
            filterMenu.classList.toggle('cat-filter-active');
            bodyBackdrop.classList.toggle('visible');
            document.body.classList.toggle('active-backdrop');
        }
    }

    // Accordion toggle icon behaviour
    accordionToggle() {
    $('#category-accordion').on('hide.bs.collapse show.bs.collapse', (e) => {
        $(e.target)
            .prev()
            .find('.toggle-icon')
            .toggleClass('icon-reverse-y');
    })
}

    /** Copy data between form on the order page **/
    copyFormData() {
        let checkbox = document.querySelector('#copyFields');

        if (checkbox === null) {
            return;
        }

        let inputsArray = [
            '_first_name',
            '_last_name',
            '_email',
            '_phone',
            '_address_country',
            '_address_region',
            '_address_city',
            '_address_zip',
            '_address_address'
        ];

        checkbox.addEventListener('change', () => {
            let self = this;

            inputsArray.forEach((item) => {
                let billingItems = document.querySelector('#billing' + item);
                let orderItems = document.querySelector('#order' + item);

                if (self.checked) {
                    billingItems.value = orderItems.value;
                } else {
                    billingItems.value = null;
                }
            });
        });
    }

    /** Chechbox checker on order page **/
    aszfCheckbox() {
        let checkbox = document.querySelector('#aszf');
        let submitBtn = document.querySelector('#order-submit');

        if (checkbox === null || submitBtn === null) {
            return;
        }

        checkbox.addEventListener('change', () => {
            if (checkbox.checked) {
                submitBtn.removeAttribute('disabled');
            } else {
                submitBtn.setAttribute('disabled', '');
            }
        })
    }

    /** Sorting the lists - Append "sort" URL parameter and reload page **/
    listSortDropdown() {

        if (document.querySelector('#sort-list') === null) {
            return;
        }

        document.querySelector('#sort-list').addEventListener('change', (e) => {

            if (e.target.value != '-') {
                let urlParams = new URLSearchParams(window.location.search);
                urlParams.set('sort', e.target.value);
                urlParams.toString();

                window.location.search = urlParams.toString();
            }
        });
    }
}

export default new HDTrade();
